import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";



export default function GenerateClaimDialog({ visible, onHide, responseMessage, loading }) {
  console.log("GenerateClaimDialog", { visible, onHide, responseMessage, loading });
  return (
    <Dialog
      header="Generar Siniestro"
      visible={visible}
      onHide={onHide}
      style={{ width: "30rem" }}
      draggable={false}
    >
      {loading && (
        <div className="p-fluid text-center">
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          />
          <p>Cargando...</p>
        </div>
      )}
      {responseMessage && (
        <div className="p-fluid">
          <p>{responseMessage}</p>
          <Button
            label="Cerrar"
            icon="pi pi-times"
            onClick={() => {
              onHide();
            }}
          />
        </div>
      
      )}
    </Dialog>
  );
}
